import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppRow from "src/commun/composants/grille/AppRow";
import styles from "./AppTuile.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppState } from "src/app/state/StateProvider";
import { ActiveService } from "src/domain/User";
import { fetchFavoris, supprimerFavori } from "src/app/api/AccountApi";
import AppIcon from "src/commun/composants/AppIcon";
import Stack from "react-bootstrap/Stack";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";
import AppAsyncImage from "src/commun/composants/AppAsyncImage/AppAsyncImage";

export type AppTuileProps = {
  service: ActiveService;
}

const AppTuileFavori = ({ service }: AppTuileProps) => {
  const { tString } = useAppText();
  const navigate = useNavigate();
  const [{ langue }, dispatch] = useAppState();

  let label;
  if (langue === "fr") {
    label = service.labelFr;
  } else if (langue === "de") {
    label = service.labelDe;
  } else {
    label = service.labelEn;
  }

  const refreshFavoris = () => {
    fetchFavoris().then(result => {
      dispatch({ type: "setFavoris", payload: result });
    });
  };

  const removeFavori = (codeService: string) => {
    supprimerFavori({ "codeService": codeService }).then(() => {
      refreshFavoris();
    });
  };

  return (
    <AppCol
      lg
      className={`${styles.tuileContainer} ${styles.tuileFavoriContainer} ${service.url && "cursor-pointer"}`}
      onClick={() => {
        if (service.url) {
          goToUrl(service.url, service.openInNewTab, navigate);
        }
      }}>
      <AppRow>
        {service.flagNew && <span className={`${styles.flagNew}`}>{tString("service.pub.nouveau")}</span>}
        <AppCol xs={1} className={`${styles.iconContainer}`}>
          <AppAsyncImage
            serviceCode={service.serviceCode}
            alt={label}
            className={styles.iconServiceFavori}
          />
        </AppCol>
        <AppCol xs className={styles.table}>
          <Stack className={styles.tableCell}>
            <span className={styles.serviceName}>{label}</span>
            {(service.nbDaysLeft || service.nbDaysLeft === 0) &&
              <span className={styles.serviceJoursRestants}>({service.nbDaysLeft} {tString("service.joursRestants")})</span>}
          </Stack>
          <div className={`${styles.tableCell} ${styles.stickEnd} ${styles.leftVerticalLine}`}>
            <AppIcon
              title={tString("favoris.supprimer")}
              className={`cursor-pointer bolderOnHover couleurIconBleu ${styles.tableCell} ${styles.iconRemoveFavori}`}
              name="star-full"
              size="15px"
              onClick={(event) => {
                removeFavori(service.serviceCode);
                event.stopPropagation();
              }}/>
          </div>
          {service.url && (
            <div className={`${styles.tableCell} ${styles.stickEnd} ${styles.leftVerticalLine}`}>
              <AppIcon
                title={tString("global.acceder")}
                name={"suivant"}
                className={`${styles.btnAcceder} ${styles.tableCell}`}
              />
            </div>
          )}
        </AppCol>
      </AppRow>
    </AppCol>
  );
};

export default AppTuileFavori;
